import { createContext } from 'react';

export const PostPurchaseContext = createContext(null);
export const PostPurchaseDispatchContext = createContext(null);